

















import { Component, Mixins } from 'vue-property-decorator';
import { TjipFormItemTextMixin, TjipFormControlValueMixin } from '@tjip/vuejs';
import includes from 'lodash/includes';
import find from 'lodash/find';

@Component({})
export class AppFormControlTelefoonnummerComponent extends Mixins(TjipFormControlValueMixin, TjipFormItemTextMixin) {
  protected allowKey(key: string): boolean {
    return includes('+0123456789', key);
  }

  protected allowValue(value: string): boolean {
    return !find(value, v => !this.allowKey(v));
  }
}

export default AppFormControlTelefoonnummerComponent;
